var spinCoords = {x: 946, y: 689},
    autoCoords = {x: 859, y: 706 + 3},
    betCoords = {x: 790, y: 706},
    plus_y = 707,
    label_y = 705,
    text_y = 735;


module.exports = {

    main_panel: {
        frame: 'main_panel.png',
        position:{x:75, y:695},
    },

    progressive_jackpot_panel: {
        position:{x:232, y:665 - 1},
        coin : [
            47,
             11,
        ],
        banknotes : [
             182,
             11,
        ],
        diamonds : [
             312,
             11,
        ],
        starts : [
             442,
             11,
        ],
        background : 'jp_ingame_panel.png',
    },

    common: {
        font:'userinterface_new-font'
    },

    buttons: {
        spin: {
            frames:{
                normal:'spin_normal.png',
                pressed:'spin_pressed.png',
                disabled:'spin_normal.png',
                hover: 'spin_normal.png'
            },
            hitArea:'circle',
            position:{x:spinCoords.x, y:spinCoords.y}
        },

        collect: {
            frames:{
                normal:'collect_normal.png',
                pressed:'collect_pressed.png',
                disabled:'collect_normal.png',
                hover: 'collect_normal.png'
            },
            hitArea:'circle',
            position:{x:spinCoords.x, y:spinCoords.y}
        },

        stop: {
            frames:{
                normal:'stop_normal.png',
                pressed:'stop_pressed.png',
                disabled:'stop_disabled.png',
                hover: 'stop_normal.png'
            },
            hitArea:'circle',
            position:{x:spinCoords.x, y:spinCoords.y}
        },

        start: {
            frames:{
                normal:'start_normal.png',
                pressed:'start_pressed.png',
                disabled:'start_disabled.png',
                hover: 'start_normal.png'
            },
            hitArea:'circle',
            position:{x:spinCoords.x, y:spinCoords.y}
        },

        finish: {
            frames:{
                normal:'finish_normal.png',
                pressed:'finish_pressed.png',
                disabled:'finish_disabled.png',
                hover: 'finish_normal.png'
            },
            hitArea:'circle',
            position:{x:spinCoords.x, y:spinCoords.y}
        },

        info: {
            frames:{
                normal:'info_normal.png',
                pressed:'info_pressed.png',
                disabled:'info_disabled.png',
                hover: 'info_normal.png'
            },
            hitArea:'circle',
            position:{x:51, y:657}
        },

        sound_on: {
            frames:{
                normal:'sound_off.png',
                pressed:'sound_off.png',
                disabled:'sound_off.png',
                hover: 'sound_off.png'
            },
            hitArea:'circle',
            position:{x:923, y:657}
        },

        sound_off: {
            frames:{
                normal:'sound_on.png',
                pressed:'sound_on.png',
                disabled:'sound_on.png',
                hover: 'sound_on.png'
            },
            hitArea:'circle',
            position:{x:923, y:657}
        },

        gamble: {
            frames:{
                normal:'gamble_normal.png',
                pressed:'gamble_pressed.png',
                disabled:'gamble_disabled.png',
                hover: 'gamble_normal.png'
            },
            position:{x:autoCoords.x - 3, y:betCoords.y}
        },

        betmax: {
            frames:{
                normal:'bet_max_normal.png',
                pressed:'bet_max_pressed.png',
                disabled:'bet_max_normal.png',
                hover: 'bet_max_normal.png'
            },
            position:{x:betCoords.x, y:betCoords.y}
        },

        betmin: {
            frames:{
                normal:'bet_min_normal.png',
                pressed:'bet_min_pressed.png',
                disabled:'bet_min_normal.png',
                hover: 'bet_min_normal.png'
            },
            position:{x:betCoords.x, y:betCoords.y}
        },

        autoplay: {
            frames:{
                normal:'autoplay_normal.png',
                pressed:'autoplay_on.png',
                disabled:'autoplay_normal.png',
                hover: 'autoplay_normal.png'
            },
            position:{x:autoCoords.x, y:autoCoords.y}
        },

        autoplayoff: {
            frames:{
                normal:'autoplay_on.png',
                pressed:'autoplay_on.png',
                disabled:'autoplay_disabled.png',
                hover: 'autoplay_on.png'
            },
            position:{x:autoCoords.x, y:autoCoords.y}
        },

        menu: {
            frames:{
                normal:'lobby_normal.png',
                pressed:'lobby_pressed.png',
                disabled:'lobby_disabled.png',
                hover: 'lobby_normal.png'
            },
            //hitArea:'circle',
            active_area: {
                circle: {
                    x: 36,
                    y: 37,
                    r: 35
                }
            },
            position:{x:1, y:spinCoords.y}
        },

        decrease_lines: {
            frames:{
                normal:'minus_normal.png',
                pressed:'minus_pressed.png',
                disabled:'minus_disabled.png',
                hover: 'minus_normal.png'
            },
            hitArea:'circle',
            position:{x:94, y:plus_y}
        },

        increase_lines: {
            frames:{
                normal:'plus_normal.png',
                pressed:'plus_pressed.png',
                disabled:'plus_disabled.png',
                hover: 'plus_normal.png'
            },
            hitArea:'circle',
            position:{x:198, y:plus_y}
        },

        lines: {
            frames:{
                normal:'lines_normal.png',
                pressed:'lines_pressed.png',
                disabled:'lines_disabled.png',
                hover: 'lines_normal.png'
            },
            position:{x:128, y:label_y}
        },

        decrease_linebet: {
            frames:{
                normal:'minus_normal.png',
                pressed:'minus_pressed.png',
                disabled:'minus_disabled.png',
                hover: 'minus_normal.png'
            },
            hitArea:'circle',
            position:{x:259, y:plus_y}
        },

        increase_linebet: {
            frames:{
                normal:'plus_normal.png',
                pressed:'plus_pressed.png',
                disabled:'plus_disabled.png',
                hover: 'plus_normal.png'
            },
            hitArea:'circle',
            position:{x:372, y:plus_y}
        },

        linebet: {
            frames:{
                normal:'line_bet_normal.png',
                pressed:'line_bet_pressed.png',
                disabled:'line_bet_disabled.png',
                hover: 'line_bet_normal.png'
            },
            position:{x:295, y:label_y}
        },
        next: {
            frames: {
                normal:"next_normal.png",
                hover: 'next_hover.png',
                pressed:"next_pressed.png",
                disabled:"next_disabled.png"
            },
            position:{x:826,y:700}
            // active_area:{x:14,y:14,w:183,h:121}
        },
        exit: {
            frames: {
                normal:"exit_normal.png",
                hover: 'exit_hover.png',
                pressed:"exit_pressed.png",
                disabled:"exit_disabled.png"
            },
            position:{x:414, y:700}
            // active_area:{x:15,y:15,w:118,h:118}
        },
        back: {
            frames: {
                normal:"back_normal.png",
                hover: 'back_hover.png',
                pressed:"back_pressed.png",
                disabled:"back_disabled.png"
            },
            position:{x:14, y:700}
            // active_area:{x:12,y:15,w:185,h:119}
        }
    },

    frames: {
        lines:{
            frame:'',
            text_position:{x:3, y:3},
            text_align:{x:0.5, y:0.5},
            position:{x:167, y:text_y}
        },

        line_bet:{
            frame:'',
            text_position:{x:3, y:3},
            text_align:{x:0.5,y:0.5},
            position:{x:335, y:text_y}
        },

        win:{
            frame:'ui_win_label.png',
            font: 'userinterface_win-font',
            text_position:{x:44, y:37},
            text_align:{x:0.5, y:0.5},
            position:{x:469, y:699}
        },

        credits:{
            frame: 'credits.png',
            text_position:{x:43, y:text_y - label_y + 3},
            text_align:{x:0.5, y:0.5},
            position:{x:692, y:label_y}
        },

        credits_risk:{
            frame:'credits_risk.png',
            text_position:{x:83, y:44},
            text_align:{x:0.5, y:0.5},
            position:{x:429, y:695}
        },

        total_bet:{
            frame:'total_bet.png',
            text_position:{x:48, y:text_y - label_y + 3},
            text_align:{x:0.5, y:0.5},
            position:{x:595, y:label_y}
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/library/cfg/userinterface-config.js
// module id = 96
// module chunks = 0